var api_url;
var base_url;
var vendor_images_path;
var customer_files_path;
var node_api_url;
var python_api_url;
var slashrtc_clicktodial;

if (process.env.REACT_APP_ENVIRONMENT === "test") {
  api_url = "http://test.api.boxigo.in/product/";
  base_url = "http://test.boxigo.in/";
  vendor_images_path = "http://test.boxigo.in/customer/vendor-images/";
  customer_files_path = "http://test.boxigo.in/customer/additional_files/";
  node_api_url = "http://test.node.api.boxigo.in/api/admin/";
  python_api_url = "http://test.ai.ml.boxigo.in/py/";
  slashrtc_clicktodial = `${node_api_url}click-to-dial`;
}
if (process.env.REACT_APP_ENVIRONMENT === "dev") {
  api_url = "http://localhost/boxigo-backend-api/product/";
  base_url = "http://localhost/boxigo_customer_portal/";
  vendor_images_path = "http://localhost/vendor/";
  customer_files_path = "http://localhost/customer/additional_files/";
  node_api_url = "http://localhost:5000/api/admin/";
  python_api_url = "http://127.0.0.1:5000/";
  slashrtc_clicktodial = `${node_api_url}click-to-dial`;
}

if (process.env.REACT_APP_ENVIRONMENT === "prod") {
  api_url = "https://api.boxigo.in/product/";
  base_url = "https://boxigo.in/";
  vendor_images_path = "https://boxigo.in/vendor-images/";
  customer_files_path = "https://boxigo.in/customer/additional_files/";
  node_api_url = "https://nodeapi.boxigo.in/api/admin/";
  python_api_url = "https://ai.boxigo.in/py/";
  slashrtc_clicktodial = `${node_api_url}click-to-dial`;
}

export { api_url, base_url, vendor_images_path, customer_files_path, slashrtc_clicktodial, node_api_url, python_api_url };
export const cors_bypass = "";